<template lang="pug">
  TeamBuilder(:mode="$route.params.mode")
</template>

<script>
import TeamBuilder from "@@/TeamBuilder/TeamBuilder";

export default {
  name: "MemberTeamBuilder",

  components: { TeamBuilder }
};
</script>

<style lang="sass" scoped></style>
